"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export type InspectionCreatePayload = TypeOf<typeof InspectionCreatePayloadSchema>;
//# sourceMappingURL=inspectionModel.js.map